import React, { useState, useEffect } from "react";

import axios from "axios";
import { server } from "../../../utills/utils";

import Spinner from "../../Modals/SpinnerModal";
import Modal from "../../Modals/CancelModal";
import ShopItem from "./ShopItem";

import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  display: flex;
  flex-flow: wrap;
`;

const Button1 = styled.button`
  width: 48.5%;
  padding: 10px;
  margin: 5px 5% 0 0;
  font-size: 1em;
  background: #ff5d5d;
  border: none;
  color: white;
  border-radius: 5px;
  cursor: pointer;
`;
const Button2 = styled.button`
  width: 45%;
  padding: 10px;
  border: none;
  border-radius: 5px;
  font-size: 1em;
  cursor: pointer;
`;

const CancelTitle = styled.p``;
// const ShopItem = (props) => {
//   return (
//     <Shop>
//       <ShopTitle>{props.shop.name}</ShopTitle>
//       <SecondTitle>{props.shop.phone}</SecondTitle>
//       <SecondTitle>{props.shop.email}</SecondTitle>
//       <SecondTitle>{props.shop.location}</SecondTitle>
//       <div style={{ margin: "5px 0" }}>
//         <p style={{ padding: "0", margin: "5px 0" }}>Select a plan</p>
//         <SelectInput
//           // onChange={planHandler}
//         >
//           <option>30 days</option>
//           <option>60 days</option>
//           <option>120 days</option>
//           <option>365 days</option>
//         </SelectInput>
//       </div>
//       <Button1
//         onClick={() => {
//           props.onBoardHandler(props.shop._id);
//         }}
//       >
//         On board
//       </Button1>
//       <Button2 onClick={() => props.cancelModaHandler(props.shop._id)}>
//         Cancel
//       </Button2>
//     </Shop>
//   );
// };
function ShopsRequest() {
  const [shops, setShops] = useState([]);
  const [complete, setComplete] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [cancelId, setCancelId] = useState(null);

  const fetchShops = async () => {
    try {
      const shops = await axios.post(server, {
        query: `
                    query{
                        shopsRequest{
                            _id
                            name
                            phone
                            email
                            location
                            cityName
                            thanaName
                            categoryName
                        }
                    }
                  `,
      });
      console.log("Find shops", shops);
      setShops(shops.data.data.shopsRequest);
      setComplete(true);
    } catch (error) {
      throw error;
    }
  };
  const onBoardShop = async (shopId, days) => {
    try {
      console.log("Days", days);
      setSpinner(true);
      let date = new Date();
      date.setDate(date.getDate() + days);
      console.log("Date", date.toISOString());

      const shop = await axios.post(server, {
        query: `
                    mutation{
                        onBoardShop(shopId:"${shopId}", date:"${date.toISOString()}"){
                          _id
                          name
                          phone
                          email
                          location
                          cityName
                          thanaName
                          categoryName
                        }
                    }
                  `,
      });
      setShops(shop.data.data.onBoardShop);
      setSpinner(false);
    } catch (error) {
      throw error;
    }
  };
  const cancelRequest = async (shopId) => {
    try {
      setCancel(false);
      setSpinner(true);

      const shop = await axios.post(server, {
        query: `
                    mutation{
                       cancelShopRequest(shopId:"${shopId}"){
                        _id
                        name
                        phone
                        email
                        location
                        cityName
                        thanaName
                        categoryName
                        }
                    }
                  `,
      });
      setShops(shop.data.data.cancelShopRequest);
      setSpinner(false);
      setCancelId(null);
    } catch (error) {
      throw error;
    }
  };

  const cancelModaHandler = (id) => {
    setCancel(true);
    setCancelId(id);
  };
  const cancelCloseHandler = () => {
    setCancel(false);
    setCancelId(null);
  };

  useEffect(() => {
    fetchShops();
  }, []);
  return (
    <div>
      <Spinner show={spinner} />

      <Modal show={cancel} closeModal={cancelCloseHandler}>
        <CancelTitle>
          Are you sure want to cancel this shop request permanently ?
        </CancelTitle>
        <Button1
          onClick={() => {
            cancelRequest(cancelId);
          }}
        >
          Yes
        </Button1>
        <Button2 onClick={cancelCloseHandler}>No</Button2>
      </Modal>

      {complete ? (
        <Container>
          {shops.length > 0 ? (
            shops.map((shop, id) => {
              return (
                <ShopItem
                  cancelModaHandler={cancelModaHandler}
                  onBoardHandler={onBoardShop}
                  key={shop._id}
                  shop={shop}
                />
              );
            })
          ) : (
            <p>No shops request</p>
          )}
        </Container>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default ShopsRequest;
